export default __webpack_public_path__ + "static/media/viber.7fd076f3.svg";